import React from 'react';
import PropTypes from 'prop-types';
import {confirmable} from 'react-confirm';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Dialog from 'components/pure/utils/Dialog';
import Button from '@material-ui/core/Button';
import 'styles/utils/ConfirmDialog.styl';
import {ThemeProvider} from '@components/@theme';
import {lightTheme} from '@components/@theme/lightTheme';
import {getMuiV0Theme} from 'utils/css/themeUtils';

class ConfirmDialog extends React.PureComponent {
  render() {
    const {show, proceed, cancel, confirmation, title = 'Confirmation Required'} = this.props;

    return (
      <MuiThemeProvider muiTheme={getMuiTheme(getMuiV0Theme())}>
        <Dialog
          title={<div key="title">{title}</div>}
          contentClassName="confirm-dialog"
          closeButton={true}
          actions={[
            <ThemeProvider theme={lightTheme}>
              <Button variant="contained" color="primary" className="ev-button" onClick={proceed}>
                Yes
              </Button>
              <Button variant="outlined" className="ev-button" onClick={cancel}>
                No
              </Button>
            </ThemeProvider>,
          ]}
          open={show}
          onRequestClose={cancel}>
          {/*
            EV-16953
            Div that can steal focus from anything (say a link or a button) that may have
            triggered this dialog in the first place, to avoid popping up multiple instances
            if the user hits enter.
           */}
          <div style={{outline: 'none'}} tabIndex={0} ref={r => r && r.focus()}>
            {confirmation}
          </div>
        </Dialog>
      </MuiThemeProvider>
    );
  }
}

ConfirmDialog.propTypes = {
  show: PropTypes.bool, // from confirmable. indicates if the dialog is shown or not.
  proceed: PropTypes.func, // from confirmable. call to close the dialog with promise resolved.
  cancel: PropTypes.func, // from confirmable. call to close the dialog with promise rejected.
  confirmation: PropTypes.any, // confirmation message to display.
};

export default confirmable(ConfirmDialog);
